module.exports = __webpack_public_path__ + "img/161.3488d585.jpg";